import { useState } from 'react'

import { type StopAppointment } from 'core/appointments/domain/Appointment'

import { Reschedule } from './Reschedule'
import { Scheduled } from './Scheduled'

const STEPS = {
  SCHEDULED: 'scheduled',
  RESCHEDULE: 'reschedule',
}

export function StepContent({
  appointment,
  onCancelAppointment,
}: {
  appointment?: StopAppointment
  onCancelAppointment: () => void
}) {
  const [step, setStep] = useState(STEPS.SCHEDULED)

  function handleReschedule() {
    setStep(STEPS.RESCHEDULE)
  }

  function handleBack() {
    setStep(STEPS.SCHEDULED)
  }

  switch (step) {
    case STEPS.SCHEDULED:
      return (
        <Scheduled
          onReschedule={handleReschedule}
          onCancelAppointment={onCancelAppointment}
          appointment={appointment}
          //@TODO: Get this value from the backend
          rescheduleByCarrierForbidden={false}
        />
      )
    case STEPS.RESCHEDULE:
      return (
        <Reschedule
          onReschedule={handleReschedule}
          onBack={handleBack}
          onCancelAppointment={onCancelAppointment}
        />
      )
    default:
      return null
  }
}
